// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonBatteryChargingPlain_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.71445 3H0V10H4.47365L4.58903 9H1.00122V4H4.31182L4.71445 3ZM7.60076 9H10.0012V8.49939L11 8V5L10.0012 4.50061V4H7.47555L7.60888 3H11L11 4 12 4.5V8.5L11 9 11 10H7.1787L7.60076 9Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.27588 5.43092L7 0L4 8L5.76184 7.55954L5.24948 12L7.99948 5.00002L6.27588 5.43092Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.5 5H9.45105L9.67327 3H14V4L16 5V11L14 12V13H9.34936L10.1915 11H12.5V10.5L14 9.5V6.5L12.503 5.50203 12.5 5ZM5.81012 5H2V11H6.55065L6.32843 13H0V3H6.65223L5.81012 5Z" class="svg-bg"/>
  <path d="M9.00078 0L8.24453 6.80626L11 6.5001L11.0016 6.4999L7.00158 15.9999L7.75783 9.19367L5.00078 9.5L9.00078 0Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.8921 10.3159L13.0009 2L11.7509 5H11.7489L10.9156 7H10.9176L8.03428 13.9199L8 13.9999L11.8789 13.7015L11 22L16 10L11.8921 10.3159Z" class="svg-bg"/>
  <path d="M20 17H15.2467L14.4133 19H22V17L24 16V8L22 7V5H14.6167L14.35 7H20V8.5L22 9.5V14.5L20 15.5V17ZM11.5282 17H11.5263L11.3145 19H11.3164L11.5282 17ZM2 7H8.74893L9.58226 5H0V19H9.30332L9.51514 17H2V7Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.614 9 13.364 7H0V25H13.3901L13.5901 23H2V9H12.614ZM19.386 23H28V20.5L30 19.5V12.5L28 11.5V9H18.41L18.61 7H30V10L32 10.9231V21.0769L30 22V25H18.636L19.386 23Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17 3L15.898 14.0202L21 12.9998L15 29L16.1021 17.9795L11.0004 18.9999L17 3Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonBatteryChargingPlain is a generated icon component.
 */
let IconCommonBatteryChargingPlain = IconCommonBatteryChargingPlain_1 = class IconCommonBatteryChargingPlain extends IconBaseElement {
    render() {
        return html `${IconCommonBatteryChargingPlain_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonBatteryChargingPlain.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonBatteryChargingPlain = IconCommonBatteryChargingPlain_1 = __decorate([
    customElement('zui-icon-common-battery-charging-plain')
], IconCommonBatteryChargingPlain);
export { IconCommonBatteryChargingPlain };
